// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2Ocqi","rightAdornment":"Header_rightAdornment__3lOoy"};